var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeviceClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_device_close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_device_close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(9.000000, 9.000000) rotate(-270.000000) translate(-9.000000, -9.000000) translate(1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_keyboard_arrow_down_24px",
    transform: "translate(8.000000, 12.000000) scale(1, -1) translate(-8.000000, -12.000000) translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#1D3648",
    points: "4.94 5.89333333 8 8.94666667 11.06 5.89333333 12 6.83333333 8 10.8333333 4 6.83333333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ic_keyboard_arrow_down_24px",
    transform: "translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) "
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#1D3648",
    points: "4.94 5.89333333 8 8.94666667 11.06 5.89333333 12 6.83333333 8 10.8333333 4 6.83333333"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceClose);
export default __webpack_public_path__ + "static/media/icon_device_close.5871c312778c42c65c797d3fdeefe18b.svg";
export { ForwardRef as ReactComponent };